import { Node } from '@xyflow/react'
import { z } from 'zod'
import { isoDateTimeSchema } from '@customTypes/cloudmix/api'
import {
  projectLinkSchema,
  workflowLinkSchema,
} from '@customTypes/cloudmix/sessions/links'
import { engineIdSchema } from '@customTypes/cloudmix/engine'
import { orgIdSchema } from '@features/organisations/types'
import { mediaFormatSchema } from '@customTypes/cloudmix/common/mediaFormat'
import { sessionStatusSchema } from '@customTypes/cloudmix/sessions/status'
import { macroSchema } from '@customTypes/cloudmix/sessions/macros'
import {
  Component,
  componentSchema,
  projectComponentSchema,
} from '../sessions/components'
import {
  fallbackBehaviourSchema,
  FallbackBehaviourType,
} from '../common/fallbackBehaviour'

export const workflowSessionIdSchema = z.string().uuid()
export type WorkflowSessionId = z.infer<typeof workflowSessionIdSchema>

export const projectWorkflowSchema = z.object({
  components: z.array(projectComponentSchema),
  links: z.array(projectLinkSchema),
  macros: z.array(macroSchema).optional(),
  defaultFallbackBehaviour: fallbackBehaviourSchema
    .default({
      type: FallbackBehaviourType.black,
    })
    .nullish(),
})
export type ProjectWorkflow = z.infer<typeof projectWorkflowSchema>

export const sessionWorkflowSchema = z.object({
  components: z.array(componentSchema),
  links: z.array(workflowLinkSchema),
  macros: z.array(macroSchema).optional(),
  defaultFallbackBehaviour: fallbackBehaviourSchema
    .default({
      type: FallbackBehaviourType.black,
    })
    .nullish(),
})
export type SessionWorkflow = z.infer<typeof sessionWorkflowSchema>

export const workflowSchema = sessionWorkflowSchema
export type Workflow = z.infer<typeof workflowSchema>

export type ComponentNode = Node<Component>

export const workflowSessionDetailsSchema = z.object({
  workflowSessionId: workflowSessionIdSchema,
  name: z.string(),
  workflow: workflowSchema,
  mediaFormat: mediaFormatSchema,
  status: sessionStatusSchema,
  startedAt: isoDateTimeSchema.nullable(),
  stoppedAt: isoDateTimeSchema.nullable(),
  engineId: engineIdSchema,
  orgId: orgIdSchema,
})
export type WorkflowSessionDetails = z.infer<
  typeof workflowSessionDetailsSchema
>
